import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, Container } from 'react-bootstrap';

const Directory = () => {
  const [activeTab, setActiveTab] = useState('contractors');
  const [contractors, setContractors] = useState([]);
  const [packageHistory, setPackageHistory] = useState([]);
  const [emailHistory, setEmailHistory] = useState([]);
  const [conversionHistory, setConversionHistory] = useState([]);

  useEffect(() => {
    if (activeTab === 'contractors') {
      fetchContractors();
    } else if (activeTab === 'history') {
      fetchPackageHistory();
    } else if (activeTab === 'emails') {
      fetchEmailHistory();
    } else if (activeTab === 'conversions') {
      fetchConversionHistory();
    }
  }, [activeTab]);

  const fetchContractors = async () => {
    try {
      const response = await axios.get('https://bank2.daolog.net/contractors-info');
      setContractors(response.data);
    } catch (error) {
      console.error('Error fetching contractors:', error);
    }
  };

  const fetchPackageHistory = async () => {
    try {
      const response = await axios.get('https://bank2.daolog.net/pac-history');
      setPackageHistory(response.data);
    } catch (error) {
      console.error('Error fetching package history:', error);
    }
  };

  const fetchEmailHistory = async () => {
    try {
      const response = await axios.get('https://bank2.daolog.net/email-history');
      setEmailHistory(response.data);
    } catch (error) {
      console.error('Error fetching email history:', error);
    }
  };

  const fetchConversionHistory = async () => {
    try {
      const response = await axios.get('https://bank2.daolog.net/conversion-history-l');
      setConversionHistory(response.data);
    } catch (error) {
      console.error('Error fetching conversion history:', error);
    }
  };

  const styles = {
    container: {
      fontFamily: 'Arial, sans-serif',
      maxWidth: '800px',
      margin: '120px auto 0',
      padding: '0 20px'
    },
    header: {
      color: '#333',
      borderBottom: '2px solid #333',
      paddingBottom: '10px',
      marginBottom: '20px'
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'center',
      gap: '10px',
      marginBottom: '20px'
    },
    button: {
      padding: '10px 20px',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      color: 'white',
      transition: 'background-color 0.3s'
    },
    card: {
      marginBottom: '20px',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    },
    cardItem: {
      marginBottom: '10px',
      fontSize: '16px'
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.header}>Історія</h1>

      <div style={styles.buttonContainer}>
        <button
          onClick={() => setActiveTab('contractors')}
          style={{
            ...styles.button,
            backgroundColor: activeTab === 'contractors' ? '#2196F3' : '#90CAF9'
          }}
        >
          Історія Контрагентів
        </button>
        <button
          onClick={() => setActiveTab('history')}
          style={{
            ...styles.button,
            backgroundColor: activeTab === 'history' ? '#2196F3' : '#90CAF9'
          }}
        >
          Історія пакетів
        </button>
        <button
          onClick={() => setActiveTab('emails')}
          style={{
            ...styles.button,
            backgroundColor: activeTab === 'emails' ? '#2196F3' : '#90CAF9'
          }}
        >
          Історія емейлів
        </button>
        <button
          onClick={() => setActiveTab('conversions')}
          style={{
            ...styles.button,
            backgroundColor: activeTab === 'conversions' ? '#2196F3' : '#90CAF9'
          }}
        >
          Історія конвертацій
        </button>
      </div>

      <Container>
        {activeTab === 'contractors' && (
          contractors.map((contractor, index) => (
            <Card key={index} style={styles.card}>
              <div style={styles.cardItem}>
                <strong>Контрагент:</strong> {contractor.name_fop}
              </div>
              <div style={styles.cardItem}>
                <strong>ЄДРПОУ:</strong> {contractor.edrpou}
              </div>
              <div style={styles.cardItem}>
                <strong>Ресторан:</strong> {contractor.restaurant_name}
              </div>
              <div style={styles.cardItem}>
                <strong>Клієнт:</strong> {contractor.contractor_name}
              </div>
              <div style={styles.cardItem}>
                <strong>Дата активації:</strong> {new Date(contractor.created_at).toLocaleString()}
              </div>
              {contractor.del_date && (
                <div style={styles.cardItem}>
                  <strong>Дата деактивації:</strong> {new Date(contractor.del_date).toLocaleString()}
                </div>
              )}
              <div style={styles.cardItem}>
                <strong>Активував:</strong> {contractor.activator_username}
              </div>
              {contractor.deactivator_username && (
                <div style={styles.cardItem}>
                  <strong>Деактивував:</strong> {contractor.deactivator_username}
                </div>
              )}
            </Card>
          ))
        )}
        {activeTab === 'history' && (
          packageHistory.map((record, index) => (
            <Card key={index} style={styles.card}>
              <div style={styles.cardItem}>
                <strong>Старий пакет:</strong> {record.old_pac}
              </div>
              <div style={styles.cardItem}>
                <strong>Новий пакет:</strong> {record.new_pac}
              </div>
              <div style={styles.cardItem}>
                <strong>Дата зміни:</strong> {new Date(record.last_package_change).toLocaleString()}
              </div>
              <div style={styles.cardItem}>
                <strong>Клієнт:</strong> {record.contractor_name}
              </div>
              <div style={styles.cardItem}>
                <strong>Користувач:</strong> {record.username}
              </div>
            </Card>
          ))
        )}
        {activeTab === 'emails' && (
          emailHistory.map((record, index) => (
            <Card key={index} style={styles.card}>
              <div style={styles.cardItem}>
                <strong>Хто вносив зміну:</strong> {record.username}
              </div>
              <div style={styles.cardItem}>
                <strong>Старий email:</strong> {record.old_name}
              </div>
              <div style={styles.cardItem}>
                <strong>Новий email:</strong> {record.new_name}
              </div>
              <div style={styles.cardItem}>
                <strong>Дата зміни:</strong> {new Date(record.date_change).toLocaleString()}
              </div>
              <div style={styles.cardItem}>
                <strong>Клієнт:</strong> {record.contractor_name}
              </div>
              <div style={styles.cardItem}>
                <strong>Тип зміни:</strong> {record.type}
              </div>
            </Card>
          ))
        )}
        {activeTab === 'conversions' && (
          conversionHistory.map((record, index) => (
            <Card key={index} style={styles.card}>
              <div style={styles.cardItem}>
                <strong>Номер конвертації:</strong> {record.id}
              </div>
              <div style={styles.cardItem}>
                <strong>Користувач:</strong> {record.username}
              </div>
              <div style={styles.cardItem}>
                <strong>Дата конвертації:</strong> {new Date(record.conversion_date).toLocaleString()}
              </div>
              <div style={styles.cardItem}>
                <strong>Тип банку:</strong> {record.bank_type}
              </div>
              <div style={styles.cardItem}>
                <strong>Шлях до файлу:</strong> {record.path}
              </div>
            </Card>
          ))
        )}
      </Container>
    </div>
  );
};

export default Directory;